import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import React, { Component } from "react";

import AICommandBox from "../../js/ai/AICommandBox";
import BackButton from "../../components/menus/BackButton";
import EatWithMeText from "../../components/EatWIthMeText";
import FlexGrowSpace from "../../widgets/FlexGrowSpace";
import RestaurantSelector from "../../components/RestaurantSelector";
import OpeningHoursComponent from "./OpeningHoursComponent";

class OpeningHours extends Component {
  state = {};
  render() {
    return this.props.myStatus.restaurant_id ? (
      <div id="openingHours" style={{ display: "flex", flexFlow: "column", flexGrow: 1, flexShrink: 1, overflow: "hidden", height: "100%" }}>
        <div
          className="menuItemHeader"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            height: "50px",
            alignItems: "center",
            fontSize: "18px",
            backgroundColor: "#FAF8EA",
            color: "#837B6C",
            paddingLeft: "30px",
            paddingRight: "30px",
            flexShrink: 0,
          }}
        >
          <EatWithMeText />
          <BackButton {...this.props} />
          <FlexGrowSpace />
          <RestaurantSelector {...this.props} disableDropdown />
          <FlexGrowSpace />
          <span className="myTitle" >
            {<Translate value="admin_local.menus.opening_hours" />}
          </span>
        </div>
        <OpeningHoursComponent />
        <AICommandBox />
      </div>
    ) : (
      ""
    );
  }


}

const mapStateToProps = (props, state) => {
  if (props.rootReducer.myStatus) {
    return {
      restaurant: props.rootReducer.restaurant,
      myStatus: props.rootReducer.myStatus,
      admin_local: props.rootReducer.admin_local,
      local: props.rootReducer.local,
      speechRecognitionOn: props.rootReducer.speechRecognitionOn,
      ai: props.rootReducer.ai,
      speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable
    };
  }
  return {};
};

export default connect(mapStateToProps)(OpeningHours);
